export default {"src":"/_next/static/media/thoughts.e6afa20b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};